import React from 'react';
import { Route, Switch, useParams, Redirect } from 'react-router-dom';
import EnableForProjectState from '../security/EnableForProjectState';

const InsightsContentRouter = () => {
  const { projectId } = useParams();
  const path = '/projects/:projectId/insights';

  return (
    <EnableForProjectState projectId={projectId}>
      {() => (
        <Switch>
          <Route
            path={path}
            render={() => <Redirect to={`/projects/${projectId}`} />}
          />
          <Route
            path={`${path}/:insightId/view`}
            render={() => <Redirect to={`/projects/${projectId}`} />}
          />
          <Route
            path={`${path}/create`}
            render={() => <Redirect to={`/projects/${projectId}`} />}
          />
          <Route
            path={`${path}/:insightId/edit`}
            render={() => <Redirect to={`/projects/${projectId}`} />}
          />
        </Switch>
      )}
    </EnableForProjectState>
  );
};

export default InsightsContentRouter;
